import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { hasMinimumLength, stringToCheck } from '@/utils/resultsHelper';

const CohortAxisDropdownItems = ({
  value,
  fields,
  filterText,
  onChange,
}) => {
  const text = stringToCheck(filterText).toLowerCase();
  const items = hasMinimumLength(text)
    ? fields.filter(({ label, name }) => (name.toLowerCase().includes(text) || label.toLowerCase().includes(text)))
    : fields;

  return (
    items.map((field) => (
      <Dropdown.Item
        key={`cohort_axis_dropdown_${field.name}`}
        text={field.label}
        description={field.name}
        value={field.name}
        active={field.name === value}
        onClick={() => onChange(field.name, field.label)}
      />
    ))
  );
};

export default CohortAxisDropdownItems;
